var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23, _circle24, _circle25, _circle26, _circle27, _circle28, _circle29, _circle30, _circle31, _circle32, _circle33;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStars(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 330,
    height: 158,
    viewBox: "0 0 330 158",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    r: 3,
    transform: "matrix(-1 0 0 1 23 45)",
    fill: "#FFC266"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    r: 3,
    transform: "matrix(-1 0 0 1 23 45)",
    fill: "#FFC266"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    r: 3,
    transform: "matrix(-1 0 0 1 23 45)",
    fill: "#FFC266"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    transform: "matrix(-1 0 0 1 54.5 25.5)",
    fill: "#FFC266"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    transform: "matrix(-1 0 0 1 54.5 25.5)",
    fill: "#FFC266"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    transform: "matrix(-1 0 0 1 54.5 25.5)",
    fill: "#FFC266"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    r: 2.5,
    transform: "matrix(-1 0 0 1 84.5 78.5)",
    fill: "#FFC266"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    r: 2.5,
    transform: "matrix(-1 0 0 1 84.5 78.5)",
    fill: "#FFC266"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    r: 2.5,
    transform: "matrix(-1 0 0 1 84.5 78.5)",
    fill: "#FFC266"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    r: 1,
    transform: "matrix(-1 0 0 1 91 129)",
    fill: "#FFC266"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    r: 1,
    transform: "matrix(-1 0 0 1 91 129)",
    fill: "#FFC266"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    r: 1,
    transform: "matrix(-1 0 0 1 91 129)",
    fill: "#FFC266"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    r: 2.5,
    transform: "matrix(-1 0 0 1 164.5 39.5)",
    fill: "#FFC266"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    r: 2.5,
    transform: "matrix(-1 0 0 1 164.5 39.5)",
    fill: "#FFC266"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    r: 2.5,
    transform: "matrix(-1 0 0 1 164.5 39.5)",
    fill: "#FFC266"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    transform: "matrix(-1 0 0 1 267.5 22.5)",
    fill: "#FFC266"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    transform: "matrix(-1 0 0 1 267.5 22.5)",
    fill: "#FFC266"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    transform: "matrix(-1 0 0 1 267.5 22.5)",
    fill: "#FFC266"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    r: 3.5,
    transform: "matrix(-1 0 0 1 194.5 3.5)",
    fill: "#FFC266"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    r: 3.5,
    transform: "matrix(-1 0 0 1 194.5 3.5)",
    fill: "#FFC266"
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    r: 3.5,
    transform: "matrix(-1 0 0 1 194.5 3.5)",
    fill: "#FFC266"
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    r: 3.5,
    transform: "matrix(-1 0 0 1 3.5 154.5)",
    fill: "#FFC266"
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    r: 3.5,
    transform: "matrix(-1 0 0 1 3.5 154.5)",
    fill: "#FFC266"
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    r: 3.5,
    transform: "matrix(-1 0 0 1 3.5 154.5)",
    fill: "#FFC266"
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    r: 4.5,
    transform: "matrix(-1 0 0 1 157.5 109.5)",
    fill: "#FFC266"
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    r: 4.5,
    transform: "matrix(-1 0 0 1 157.5 109.5)",
    fill: "#FFC266"
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    r: 4.5,
    transform: "matrix(-1 0 0 1 157.5 109.5)",
    fill: "#FFC266"
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    r: 2,
    transform: "matrix(-1 0 0 1 267 148)",
    fill: "#FFC266"
  })), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    r: 2,
    transform: "matrix(-1 0 0 1 267 148)",
    fill: "#FFC266"
  })), _circle30 || (_circle30 = /*#__PURE__*/React.createElement("circle", {
    r: 2,
    transform: "matrix(-1 0 0 1 267 148)",
    fill: "#FFC266"
  })), _circle31 || (_circle31 = /*#__PURE__*/React.createElement("circle", {
    r: 2.5,
    transform: "matrix(-1 0 0 1 327.5 125.5)",
    fill: "#FFC266"
  })), _circle32 || (_circle32 = /*#__PURE__*/React.createElement("circle", {
    r: 2.5,
    transform: "matrix(-1 0 0 1 327.5 125.5)",
    fill: "#FFC266"
  })), _circle33 || (_circle33 = /*#__PURE__*/React.createElement("circle", {
    r: 2.5,
    transform: "matrix(-1 0 0 1 327.5 125.5)",
    fill: "#FFC266"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStars);
export default __webpack_public_path__ + "static/media/stars.d33b0b7343ae10e70f36a54381d36d9c.svg";
export { ForwardRef as ReactComponent };